import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import App from "./App";
import LoadingScreen from "./LoadingScreen";
import AdminPage from "./AdminPage";
import OutreachPage from "./OutreachPage";

const RNR_PDF_URL =
  "https://firebasestorage.googleapis.com/v0/b/btui-25.firebasestorage.app/o/BTUI%2726_RnR.pdf?alt=media&token=4d0cdc8c-d6df-4d86-b506-14562e94c17b";

function ExternalRedirect({ to }) {
  React.useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>       
        {/* Admin Panel Route */}
        <Route path="/admin" element={<AdminPage />} />

        {/* School outreach tracker */}
        <Route path="/outreach" element={<OutreachPage />} />
        <Route path="/outreach/team" element={<OutreachPage />} />
        
        {/* Rules & Regulations Direct Redirects */}
        <Route path="/rnr" element={<ExternalRedirect to={RNR_PDF_URL} />} />
        <Route path="/RnR" element={<ExternalRedirect to={RNR_PDF_URL} />} />
        <Route path="/RNR" element={<ExternalRedirect to={RNR_PDF_URL} />} />
        <Route path="/rules" element={<ExternalRedirect to={RNR_PDF_URL} />} />
        <Route path="/Rules" element={<ExternalRedirect to={RNR_PDF_URL} />} />

        {/* Main app with nested routes */}
        <Route path="/" element={<App />} />
        <Route path="/about" element={<App />} />
        <Route path="/competitions" element={<App />} />
        {/* Route-aware competitions (e.g. /competitions/armitage) */}
        <Route path="/competitions/:school" element={<App />} />
        <Route path="/contact" element={<App />} />
        <Route path="/leaderboard" element={<App />} />
        <Route path="/merchandise" element={<App />} />
        <Route path="/order" element={<App />} />
        <Route path="/orders" element={<App />} />
        <Route path="/rsvp" element={<App />} />
        
        {/* Individual competition routes - Armitage */}
        <Route path="/competitions/algorithm" element={<App />} />
        <Route path="/competitions/problem-solving" element={<App />} />
        <Route path="/competitions/web-development" element={<App />} />
        
        {/* Individual competition routes - Insignia */}
        <Route path="/competitions/photo-manipulation" element={<App />} />
        <Route path="/competitions/poster-design" element={<App />} />
        <Route path="/competitions/logo-design" element={<App />} />
        <Route path="/competitions/ui-ux-design" element={<App />} />
        
        {/* Individual competition routes - Zenith */}
        <Route path="/competitions/line-following-bot" element={<App />} />
        <Route path="/competitions/innovation-challenge" element={<App />} />
        
        {/* Individual competition routes - Orthodox */}
        <Route path="/competitions/quiz" element={<App />} />
        
        {/* ICT Society */}
        <Route path="/competitions/ict-society" element={<App />} />
        
        {/* Redirect anything else to / */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
